//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconNavTable(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M19 5V9H5V7H3V21H21V3H3V5H19ZM5 11H11V14H5V11ZM5 19V16H11V19H5ZM19 19H13V16H19V19ZM19 14H13V11H19V14Z" fill="currentColor" /></svg>;
}
export default IconNavTable;